import { buildMlpCampaignUrl } from './mlp-campaign-url.helper';

const MLP_WIDERRUF_CAMPAIGN_ID = 'c202601KFZWid';

export function buildMlpWiderrufUrl(date = new Date()): string {
  return buildMlpCampaignUrl(MLP_WIDERRUF_CAMPAIGN_ID, {}, date);
}
